import { Component, Input, OnInit } from '@angular/core';
import { CardComponent } from '../card/card.component';

@Component({
  selector: 'article-card',
  templateUrl: './article-card.component.html',
  standalone: false,
})
export class ArticleCardComponent extends CardComponent implements OnInit {
  @Input() date = '28 May, 2025';
  template = 'external';

  ngOnInit() {}
}
